import {
  TIERS_SOUS_TYPE_CONFRERE,
  TIERS_SOUS_TYPE_AFFICHEUR,
  TIERS_SOUS_TYPE_TECHNICIEN,
  TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL,
  TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON,
} from '@/configuration/tiers/tiersConf';

export const LISTE_CLIENTS = {
  title: 'Liste des clients',
  repertoire: 'Clients',
  racine: 'Accueil',
  actions: {
    filtre: 'Filtre',
    search: 'Rechercher',
    delete: 'Supprimer',
    archive: 'Archiver',
    desarchive: 'Désarchiver',
    newCustomer: 'Nouveau Client',
    exportBalance: 'Exporter Balances',
  },
  table: {
    name: 'Nom commercial',
    legalName: 'Nom juridique',
    address: 'Adresse',
    prospect: 'Prospect',
    zipCode: 'CP',
    city: 'Ville',
    phone: 'Téléphone',
    cellPhone: 'Portable',
    email: 'Email',
    accountingCode: 'Code Comptable',
    competencesFournisseur: 'Compétences fournisseur',
    internal: 'Interne',
    sousTypes: 'Rôle(s)',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    archive: 'Archivé',
    commercial: 'Commercial',
    yes: 'Oui',
    no: 'Non',
    code: 'Code(s)',
    nom: 'Nom commercial ou juridique',
    prospect: 'Prospect',
    adresse: 'Adresse(s)',
    ville: 'Ville(s)',
    clients: 'Client(s)',
    codePostal: 'Code(s) postal',
    secteurActivite: 'Secteur(s) d\'activité',
    compteComptable: 'Compte(s) comptable',
    typologie: 'Typologie(s)',
    codeMagasin: 'Code(s) magasin',
    typePointVente: 'Type(s) point de vente',
    blocageLevel: 'Niveau(x) de blocage',
    avecCoordonnees: 'Avec Coordonnees GPS',
    estLieuStockage: 'Lieu de stockage',
    marque: 'Marque(s)',
    tags: 'Tags',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
};

export const DETAIL_CLIENT = {
  title: 'Détail client {nomCommercial}',
  archive: 'Archivé',
  voirEncoursClient: 'Voir l\'encours client',
  enCoursClienAu: 'Encours client au ',
  aucunMouvement: 'Aucun mouvement',
  informationsHeader: 'Informations',
  compteHeader: 'Compte',
  lienVersClient: {
    title: 'Accès rapide',
    devis: 'Devis',
    commandes: 'Commandes',
    avoirsFacturesAcomptes: 'Factures / Avoirs / Acomptes',
    relances: 'Relances',
    planMedia: 'Plan Média',
    emplacements: 'Emplacements',
    dispositifs: 'Dispositifs',
    materiels: 'Matériels',
  },
  generalTitle: {
    prospect: 'Prospect',
    generalInformations: 'Informations générales',
    administrativeInformations: 'Informations administratives',
    contactInformations: 'Coordonnées',
    businessInformations: 'Informations commerciales',
    address: 'Adresse',
    contacts: 'Contacts',
    contactsPortail: 'Contacts pour le Portail',
    bankDetails: 'Coordonnées bancaires',
    regulationsInformations: 'Informations règlements / facturation',
    accountingInformations: 'Informations comptables',
    comments: 'Commentaires',
    organisation: 'Organisation',
    divers: 'Divers',
    roleVendeur: 'Rôle en tant que vendeur',
    portail: 'Portail',
    honoraire: 'Honoraires',
    budget: 'Budget',
    periodeBudgetaire: 'Période budgetaire',
    dispositifs: 'Dispositifs',
    lignesCommandesARenouveler: 'A renouveler',
    mouvementStock: 'Mouvement Stock',
    demandeImpression: 'Demandes d\'impressions',
    retardPaiement: 'Retard de paiement',
    devis: 'Devis',
    facture: 'Factures',
  },
  divers: {
    codeMagasin: 'Code magasin :',
    typePointVente: 'Type point de vente :',
    codeMandataire: 'Code Mandataire :',
    tiersMarque: 'Marques :',
    refExterne: 'Référence externe :',
    dateAnniversaireContrat: 'Date d\'anniversaire contrat :',
  },
  informations: {
    logo: 'Logo',
    code: 'Code client',
    tradeName: 'Nom commercial',
    legalName: 'Nom juridique',
    siret: 'Siret',
    ape: 'APE / NAF',
    intracommunityTva: 'TVA intracommunautaire',
    activity: 'Secteur d\'activité',
    profil: 'Profil de tiers',
    trade: 'Commercial',
    phone: 'Téléphone',
    cellPhone: 'Téléphone portable',
    email: 'Email',
    webSite: 'Site internet',
    postalAddress: 'Adresse postale',
    billingAddress: 'Adresse de facturation',
    entitled: 'Intitulé',
    address: 'Adresse',
    zipCode: 'Code postal',
    city: 'Ville',
    country: 'Pays',
    role: 'Rôle',
    groupe: 'Groupe : {groupe}',
    enseigne: 'Enseigne : {enseigne}',
    factureParMail: 'Factures par mail',
    applicationTva: 'Application TVA',
    prospect: 'Prospect',
    rib: {
      bankTitle: 'Banque',
      bank: 'Libellé banque',
      iban: 'IBAN',
      bic: 'BIC',
      holder: 'Titulaire',
    },
    settlementMode: 'Mode de règlement',
    settlementPeriod: 'Délai de règlement',
    endMonth: 'Fin de mois le',
    accountingAccount: 'Compte comptable',
    referenceUniqueMandat: 'Réference unique mandat',
    dayNumber: 'Nb de jours',
    commentsOrderForm: 'Commentaires Bon de commande',
    commentsBilling: 'Commentaires facturation',
    commentsIntern: 'Commentaires internes',
    instructionsDemat: 'Instructions dématérialisation',
    dateSignatureMandatSepa: 'Date de signature mandat SEPA',
    factor: 'Factor',
    typeMandatSepa: 'Type Mandat SEPA',
    locked: '"{level}" depuis le {dateLevel}',
    lockTitle: 'Niveau de blocage',
    domTom: 'Dom-Tom',
    dept: 'Dept.',
    lieuStockage: 'Lieu de stockage',
  },
  typologie: {
    pointDeVente: 'Point de vente',
    enseigne: 'Enseigne',
    groupe: 'Groupe',
    aucun: 'Aucune',
  },
  organisation: {
    title: 'Organisation',
    addEnseignePointVente: 'Associez des enseignes/points de vente pour voir l\'organisation du client "{client}"',
    aucunlienGroupe: 'Le groupe "{client}" ne contient aucune enseigne',
    aucunlienEnseigne: 'L\'enseigne "{client}" ne contient aucun point de vente',
    transfertDeStock: 'Transfert de Stock',
    noPointDeVente: 'Aucun point de vente n\'est associé à l\'enseigne {enseigne}',
    tab: {
      nom: 'Nom',
      adresse: 'Adresse',
      codePostal: 'CP',
      ville: 'Ville',
      telephone: 'Téléphone',
      portable: 'Portable',
      email: 'Email',
      soldeStock: 'Solde du stock',
    },
    popup: {
      depuis: 'Depuis',
      vers: 'Vers',
      quantite: 'Quantité',
    },
  },
  actions: {
    revert: 'Annuler',
    edit: 'Modifier',
    lock: 'Bloquer',
    unlock: 'Débloquer',
    generateMandat: 'Générer un mandat',
    createOd: 'Créer une OD',
    fusionClient: 'Fusion de client',
    deleteClient: 'Supprimer',
  },
  portail: {
    title: 'Accès portail',
    activePortail: 'Portail activé',
    desactivePortail: 'Portail désactivé',
    access: 'Accéder au portail',
    copy: 'Copier le lien',
  },
  honoraire: {
    modeCalcul: 'Mode de calcul',
    pourcentage: 'Pourcentage :',
    pourcentageApply: 'Pourcentage appliqué sur : ',
    forfait: 'Forfait :',
    manuel: 'Manuel',
    loc: 'Location',
    tlpe: 'TLPE',
    commentaire: 'Commentaire :',
  },
  periodeBudgetaire: {
    debutMois: 'Début de mois : ',
    finMois: 'Fin de mois : ',
  },
  budget: {
    budgetTotalHt: 'Budget total HT',
    tab: {
      groupe: 'Groupe',
      enseigne: 'Enseigne',
      pointDeVente: 'Point de vente',
      referencesFace: 'Face',
      lignesCommandeRegroupementLibelle: 'Patrimoine',
      lignesCommandeLibelle: 'Produit',
      dateDebut: 'Date début',
      dateFin: 'Date fin',
      montantHt: 'Montant HT',
    },
    filtre: {
      lignesCommandeRegroupementLibelle: 'Patrimoine',
      lignesCommandeLibelle: 'Produit',
      groupe: 'Groupe(s)',
      enseigne: 'Enseigne(s)',
      pointDeVente: 'Point de vente(s)',
      commercial: 'Commercial',
      factureFaite: 'Facturé',
    },
    actions: {
      exportColonne: 'Exporter par colonne',
      exportTousClient: 'Exporter pour tous les clients',
    },
  },
  popupBlocage: {
    title: 'Niveau de blocage de {nomCommercial}',
    dateBlocage: 'Date du blocage',
    level: 'Niveau du blocage',
    commentaires: 'Commentaires',
    success: 'Modification du niveau de blocage effectué',
    unselectable: 'Attention : l\'intervenant {nomCommercial} est totalement bloqué, il ne peut être sélectionné',
  },
  libelleClientForLogo: 'Client {nomCommercial}',
  sousType: {
    concurrent: 'Concurrent',
    aucun: 'Aucun',
  },
  popupGenerateMandat: {
    title: 'Générer un mandat',
    dateMandat: 'Date de signature du mandat',
    typeMandatSepa: 'Type de mandat sepa',
    rum: 'Régénérer la Référence unique de mandat',
    rumActual: 'Référence actuelle : ',
    banque: 'Banque',
    success: 'Génération du mandat éffectuée avec succès. Le fichier mandat est dans les pièces jointes ',
    normal: 'Normal',
    b2b: 'Business to Business',
  },
  dispositif: {
    tab: {
      code: 'Code',
      nom: 'Nom',
      nbFaces: 'Nb de faces',
      eclaire: 'Eclairé',
      typeMateriel: 'Type matériel',
      site: 'Site',
      format: 'Format',
      eclairable: 'Eclairable',
      type: 'Type',
      support: 'Support',
      etatMontage: 'Etat montage',
      adresse: 'Adresse',
      agence: 'Agence',
      archive: 'Archivé',
      materielFormats: 'Formats matériel',
      tailles: 'Tailles',
    },
    actions: {
      createDemandeImpression: 'Création de demande(s) d\'impression',
    },
    popUp: {
      headerPrevention: 'Etes vous sûr de vouloir créer des demandes d\'impression ?',
    },
    message: {
      successCreationDemande: 'Demandes d\'impression crées avec succès',
    },
  },
  popupFusionTiers: {
    client: {
      title: 'Fusion de client',
      tiersAConserver: 'Client à conserver',
      tiersAFusionner: 'Client à fusionner',
    },
    bailleur: {
      title: 'Fusion de bailleur',
      tiersAConserver: 'Bailleur à conserver',
      tiersAFusionner: 'Bailleur à fusionner',
    },
    collectivite: {
      title: 'Fusion de collectivité',
      tiersAConserver: 'Collectivité à conserver',
      tiersAFusionner: 'Collectivité à fusionner',
    },
    fournisseur: {
      title: 'Fusion de fournisseur',
      tiersAConserver: 'Fournisseur à conserver',
      tiersAFusionner: 'Fournisseur à fusionner',
    },
    fournisseurSupport: {
      title: 'Fusion de fournisseur de support',
      tiersAConserver: 'Fournisseur de support à conserver',
      tiersAFusionner: 'Fournisseur de support à fusionner',
    },
    [TIERS_SOUS_TYPE_CONFRERE]: {
      title: 'Fusion de confrère',
      tiersAConserver: 'Confrère à conserver',
      tiersAFusionner: 'Confrère à fusionner',
    },
    [TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL]: {
      title: 'Fusion de fournisseur de matériel',
      tiersAConserver: 'Fournisseur de matériel à conserver',
      tiersAFusionner: 'Fournisseur de matériel à fusionner',
    },
    [TIERS_SOUS_TYPE_AFFICHEUR]: {
      title: 'Fusion d\'afficheur',
      tiersAConserver: 'Afficheur à conserver',
      tiersAFusionner: 'Afficheur à fusionner',
    },
    [TIERS_SOUS_TYPE_TECHNICIEN]: {
      title: 'Fusion de technicien',
      tiersAConserver: 'Technicien à conserver',
      tiersAFusionner: 'Technicien à fusionner',
    },
    [TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON]: {
      title: 'Fusion de lieu de livraison',
      tiersAConserver: 'Lieu de livraison à conserver',
      tiersAFusionner: 'Lieu de livraison à fusionner',
    },
    adressePostale: 'Adresse postale',
    success: 'Fusion des clients effectuée avec succès',
    msgPrevention: 'Vous allez supprimer {tiersAFusionner} et le remplacer par {tiersAConserver} ?',
    errors: {
      tiersAConserverId: 'Le tiers à conserver',
      tiersAFusionnerId: 'Le tiers à fusionner',
      tiersMustBeFromTheSameCompany: 'Les deux tiers doivent être de la même société',
      tiersMustBeOfSameType: 'Les deux tiers doivent être du même type',
      tiersMustHaveAtLeastOneSousTypeInCommon: 'Les deux tiers doivent avoir au moins un sous-type en commun',
      tiersMustHaveTheSameTypology: 'Les deux tiers doivent avoir la même typologie',
      tiersToBeRetainedIsLinkedToAUser: 'Le tiers à conserver est lié à un utilisateur',
      tiersToBeRetainedIsLinkedToAtLeastOneCompany: 'Le tiers à conserver est lié à au moins une société',
      tiersToBeMergedIsLinkedToAUser: 'Le tiers à fusionner est lié à un utilisateur',
      tiersToBeMergedIsLinkedToAtLeastOneCompany: 'Le tiers à fusionner est lié à au moins une société',
    },
  },
  popupDeleteTiers: {
    title: 'Suppression du client {name}',
    mssgValidation: 'Etes-vous sûr de vouloir supprimer ce client ?',
    mssgDeleteSuccess: 'Suppression effectuée avec succès',
    errors: {
      tiersLinkedToSocieteCannotBeDeleted: 'Le client est lié à une société et ne peut être supprimé.',
      tiersLinkedToUserCannotBeDeleted: 'Le client est lié à un utilisateur et ne peut être supprimé.',
      ifOneContactLinkedToUserCannotBeDeleted: 'Un des contacts du client est lié à un utilisateur.',
      tiersUsedOnAnotherEntity: 'Le client est déjà utilisé dans l\'application.',
    },
  },
};

export const EDITION_CLIENT = {
  titleCreation: 'Créer un client',
  titleChange: 'Modifier client {nomCommercial}',
  problemOccurred: 'Un problème est survenu',
  generalTitle: {
    generalInformations: 'Informations générales',
    administrativeInformations: 'Informations administratives',
    contactInformations: 'Coordonnées',
    address: 'Adresse',
    contacts: 'Contacts',
    contactsPortail: 'Contacts pour le Portail',
    bankDetails: 'Coordonnées bancaires',
    regulationsInformations: 'Informations règlements / facturation',
    accountingInformations: 'Informations comptables',
    comments: 'Commentaires',
    organisation: 'Organisation',
    divers: 'Divers',
    roleVendeur: 'Rôle en tant que vendeur',
    portail: 'Accès portail',
    honoraire: 'Honoraires',
    periodeBudgetaire: 'Période budgetaire',
  },
  validation: {
    adresseFacturationVille: 'Adresse de facturation',
    ape: 'APE/NAF',
    accountingAccountRequired: 'Le compte comptable du destinataire comptable est obligatoire.',
    accountingAccountToLong: 'Le compte comptable du destinataire comptable est trop long pour la génération du RUM.',
    AdressePostaleCannotBeEmpty: 'Les champs "Intitulé 1" et "Ville" de l\'adresse sont obligatoires si la modification doit impacter les devis/commandes/factures',
    banque: 'Banque',
    bic: 'Bic',
    codeMagasin: 'Code magasin',
    commentairesBonDeCommandes: 'Commentaires bon de commande',
    commentairesFacturation: 'Commentaires facturation',
    commentairesInternes: 'Commentaires internes',
    compteComptable: 'Compte comptable',
    clientTypeEnseigneGroupe: 'L\'enseigne sélectionné dans l\'organisation n\'est pas de type \'Enseigne\'',
    clientTypeGroupeEnseigne: 'Le groupe sélectionné dans l\'organisation n\'est pas de type \'Groupe\'',
    calculHonoraireForfaitAmountNull: 'Vous devez indiquer un montant au forfait quand le mode de calcul est "forfait"',
    calculHonorairForfaitPercentNotNull: 'On ne doit pas avoir de pourcentage quand le mode de calcul est "forfait"',
    calculHonorairePercentNull: 'Vous devez indiquer un pourcentage quand le mode de calcul est "pourcentage"',
    calculHonorairePercentAmountNotNull: 'On ne doit pas avoir de montant quand le mode de calcul est "pourcentage"',
    dateMandat: 'Date de signature du mandat',
    email: 'L\'email est invalide.',
    iban: 'L\'iban est invalide',
    ibanLength: 'IBAN',
    intituleUn: 'Intitulé 1',
    instructionDematerialisation: 'Instructions dématérialisation',
    latitude: 'Latitude',
    lieuStockage: 'Lieu de stockage',
    longitude: 'Longitude',
    nomCommercial: 'Nom commercial',
    nomJeuneFille: 'Nom de jeune fille',
    nomJuridique: 'Nom juridique',
    numeroCedant: 'Code mandataire',
    portable: 'Téléphone portable',
    pourcentageRetrocession: 'Pourcentage de rétrocession',
    raisonSociale: 'Raison sociale',
    referenceUniqueMandat: 'Référence unique mandat',
    referenceExterne: 'Référence externe',
    siret: 'Siret',
    siteWeb: 'Site internet',
    tvaIntracommunautaire: 'TVA intracommunautaire',
    telephone: 'Téléphone',
    tiersMarques: 'Marques',
    titulaire: 'Titulaire',
    typeMandatSepa: 'Type de mandat Sepa',
    ville: 'Ville',
  },
  periodeBudgetaire: {
    debutMois: 'Début de mois',
    finMois: 'Fin de mois',
  },
  divers: {
    codeMagasin: 'Code magasin',
    typePointVente: 'Type point de vente',
    codeMandataire: 'Code Mandataire',
    tiersMarque: 'Marques',
    refExterne: 'Référence externe',
    dateAnniversaireContrat: 'Date d\'anniversaire contrat',
  },
  informations: {
    logo: 'Logo',
    code: 'Code client',
    tradeName: 'Nom commercial',
    legalName: 'Nom juridique',
    typologie: 'Typologie',
    siret: 'Siret',
    ape: 'APE / NAF',
    intracommunityTva: 'TVA intracommunautaire',
    activity: 'Secteur d\'activité',
    profil: 'Profil de tiers',
    trade: 'Commercial',
    phone: 'Téléphone',
    cellPhone: 'Téléphone portable',
    email: 'Email',
    webSite: 'Site internet',
    postalAddress: 'Adresse postale',
    city: 'Ville',
    billingAddress: 'Adresse de facturation',
    addressBillingDifferent: 'Adresse de facturation différente de l\'adresse postale.',
    factureParMail: 'Le client souhaite recevoir ses factures par mail',
    applicationTva: 'Application TVA',
    prospect: 'Prospect',
    tags: 'Tags',
    tagInfo: 'Si le tag n\'existe pas il sera créé en validant l\'entrée.',
    rib: {
      bank: 'Libellé banque',
      iban: 'IBAN',
      bic: 'BIC',
      holder: 'Titulaire',
    },
    settlementMode: 'Mode de règlement',
    settlementPeriod: 'Délai de règlement',
    endMonth: 'Fin de mois',
    accountingAccount: 'Compte comptable',
    referenceUniqueMandat: 'Référence unique mandat',
    factor: 'Factor',
    dayNumber: 'Nb de jours',
    dayMonth: 'Jour de facturation',
    commentsOrderForm: 'Commentaires Bon de commande',
    commentsBilling: 'Commentaires facturation',
    commentsIntern: 'Commentaires internes',
    instructionsDemat: 'Instructions dématérialisation',
    sameTradeNameWarning: 'Un autre client a le même nom commercial',
    role: 'Rôle',
    organisation: {
      selectEnseigne: 'Enseigne :',
      selectGroupe: 'Groupe :',
      search: 'Recherche...',
      noResult: 'Aucun résultat',
    },
    dateSignatureMandatSepa: 'Date de signature mandat SEPA',
    typeMandatSepa: 'Type Mandat SEPA',
    domTom: 'Dom-Tom',
    lieuStockage: 'Lieu de stockage',
  },
  actions: {
    revert: 'Annuler',
    addLogo: 'Ajouter un logo',
    addContact: 'Ajouter un contact',
    modifContact: 'Modifier un contact',
    addContact2: 'Ajouter',
    editContact: 'Modifier',
    saveWithoutUpdateDCF: 'Sauvegarder sans modifier l\'adresse et le nom commercial dans les devis/commandes/factures',
    addMarque: 'Créer une marque',
  },
  popUpChangementInDCF: {
    title: 'Voulez vous appliquer vos modifications d\'adresse et de nom commercial sur les devis/commandes/factures ?',
  },
  table: {
    name: 'Nom',
    description: 'Description',
    type: 'Type',
    delete: 'Supprimer',
  },
  messages: {
    successCreation: 'Création du client réalisée avec succès.',
    errorCreation: 'Enregistrement du client impossible. Les champs suivants doivent être renseignés : ',
    errorCreation2: 'Enregistrement du client impossible.',
    successChange: 'Modification du client réalisée avec succès.',
    errorChange: 'Modification du client impossible. Les champs suivants doivent être renseignés : ',
    errorChange2: 'Modification du client impossible.',
  },
  portail: {
    activePortail: 'Portail activé',
    desactivePortail: 'Portail désactivé',
    access: 'Accéder au portail',
    copy: 'Copier le lien',
  },
  honoraire: {
    modeCalcul: 'Mode de calcul',
    pourcentage: 'Pourcentage :',
    pourcentageApply: 'Pourcentage appliqué sur : ',
    forfait: 'Forfait :',
    manuel: 'Manuel',
    loc: 'Location',
    tlpe: 'TLPE',
    commentaire: 'Commentaire :',
    mode: {
      manuel: 'Manuel',
      forfait: 'Forfait',
      pourcentage: 'Pourcentage',
    },
    popUp: {
      title: 'Mode de calcul des honoraires',
      sousTitle: 'Sélectionner le mode de calcul',
      modeCalcul: 'Mode de calcul',
      pourcentage: 'Pourcentage',
      appply: 'Appliquer le pourcentage sur :',
      loc: 'Location',
      tlpe: 'TLPE',
      commentaire: 'Commentaire',
      errors: {
        oneProduct: 'Vous devez appliquer le pourcentage sur au moins un produit',
      },
    },
  },
  applicationTVAType: {
    normal: 'Normal',
    exportHorsUE: 'Export hors UE',
    intracommunautaire: 'Intracommunautaire',
    nonApplicable: 'Non applicable',
  },
};

export const SUPPRIMER_CLIENT = {
  deleteContacts: 'La suppression du client entraînera également la suppression de ses contacts.',
  irreversible: 'Cette action est irréversible.',
  delete: 'Etes-vous sûr de vouloir supprimer ce client ?',
  deleteContactsMultiple: 'La suppression des clients entraînera également la suppression de leurs contacts.',
  irreversibleMultiple: 'Cette action est irréversible.',
  deleteMultiple: 'Etes-vous sûr de vouloir supprimer ces clients ?',
  yes: 'Oui',
  no: 'Non',
  messages: {
    error: 'Suppression du client impossible. Veuillez réessayer ou contacter le service client.',
  },
};

export const ARCHIVER_CLIENT = {
  archivage: {
    action: 'Archiver',
    archiveContacts: 'L\'archivage du client entraînera également l\'archivage de ses contacts.',
    archive: 'Etes-vous sûr de vouloir archiver ce client ?',
    archiveSuccess: 'Archivage du client réalisé avec succès.',
    archiveContactsMultiple: 'L\'archivage des clients entraînera également l\'archivage de leurs contacts.',
    archiveMultiple: 'Etes-vous sûr de vouloir archiver ces clients ?',
    archiveMultipleSuccess: 'Archivage des clients réalisé avec succès.',
    messages: {
      error: 'Archivage du client impossible. Veuillez réessayer ou contacter le service client.',
    },
  },
  desarchivage: {
    action: 'Désarchiver',
    archiveContacts: 'L\'désarchivage du client entraînera également l\'désarchivage de ses contacts.',
    archive: 'Etes-vous sûr de vouloir désarchiver ce client ?',
    archiveSuccess: 'Désarchivage du client réalisé avec succès.',
    archiveContactsMultiple: 'L\'désarchivage des clients entraînera également l\'désarchivage de leurs contacts.',
    archiveMultiple: 'Etes-vous sûr de vouloir désarchiver ces clients ?',
    archiveMultipleSuccess: 'Désarchivage des clients réalisé avec succès.',
    messages: {
      error: 'Désarchivage du client impossible. Veuillez réessayer ou contacter le service client.',
    },
  },
};

export const RELANCES = {
  title: 'Relance',
  multiFacture: 'Multi-factures',
  tabs: {
    libelle: 'Relance',
    dateRelance: 'Date de relance',
    etat: 'Etat',
    numFacture: 'N° facture',
    dateFacture: 'Date de la facture',
    montant: 'Montant',
    niveauRelance: 'Niveau relance',
    commentaire: 'Commentaire',
  },
};
export const LISTE_VENTES = {
  title: 'Commandes',
  tabs: {
    reference: 'Référence',
    libelle: 'Libellé',
    nomCommercial: 'Nom client',
    adresse: 'Adresse',
    codePostal: 'CP',
    ville: 'Ville',
    format: 'Format',
    dateDebutLoc: 'Date début loc',
    dateFinLoc: 'Date fin loc',
    codeCommande: 'Code commande',
    commercial: 'Commercial',
    typeProduit: 'Type de produit',
    montant: 'Montant HT',
    dateCommande: 'Date de commande',
    codeDevis: 'Code devis',
    codeFacture: 'Code facture',
    dateDevis: 'Date de devis',
    dateFacture: 'Date de facture',
    etatDevis: 'Etat devis.',
    etatCommande: 'Etat cmd.',
    etatFacture: 'Etat fac.',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    reference: 'Référence',
    dateVentes: 'Date de vente',
    libelle: 'Libellé',
    typesProduits: 'Type(s) de produit',
    ville: 'Ville(s)',
    commercial: 'Commercial',
    etat: 'Etat(s)',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
};
